import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../RootState';

export const selectDataSuggested = createSelector(
    (state: RootState) => state.shopping_cart,
    (suggested) => suggested
);

export const selectCommercialCartSelection = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection,
    (selection) => selection
);

export const selectSelectedMonths = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.selectedMonths,
    (selectedMonths) => selectedMonths
);

export const selectSelectedPaymentMethod = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.selectedPaymentMethod,
    (selectedPaymentMethod) => selectedPaymentMethod
);

export const selectUserProfile = createSelector(
    (state: RootState) => state.shopping_cart.suggested.user_profile,
    (user_profile) => user_profile
);

export const selectSuggestedUserId = createSelector(
    (state: RootState) => state.shopping_cart.suggested.users.user_id,
    (user_id) => user_id
);

export const selectHasInputErrors = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.inputErrorByProductId,
    (inputErrorByProductId) =>
        Object.values(inputErrorByProductId).some((e) => e.price || e.quantity)
);

export const selectCartTotal = createSelector(
    (state: RootState) => state.shopping_cart.suggested.products.category,
    (state: RootState) => state.shopping_cart.suggested.selection.selectedByProductId,
    (state: RootState) => state.shopping_cart.suggested.selection.priceByProductId,
    (category, selectedByProductId, priceByProductId) => {
        const allProducts = Object.values(category).flat();
        return allProducts
            .filter((p) => selectedByProductId[p.product_id])
            .reduce((sum, p) => sum + (priceByProductId[p.product_id] ?? 0), 0);
    }
);